import styled from 'styled-components';

const icomoonClasses = [
  'print',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'caution',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'content',
  'filter',
  'globe',
  'info',
  'link',
  'theme',
  'thumbs-down-filled',
  'thumbs-down-outlined',
  'thumbs-down',
  'thumbs-up-filled',
  'thumbs-up-outlined',
  'thumbs-up',
  'tip',
  'warning-2',
  'warning',
  'zoom',
];

// https://docsstyleguide.z13.web.core.windows.net/icon-font.html
export type doconNames =
  | 'print'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'caution'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'content'
  | 'filter'
  | 'globe'
  | 'info'
  | 'link'
  | 'theme'
  | 'thumbs-down-filled'
  | 'thumbs-down-outlined'
  | 'thumbs-down'
  | 'thumbs-up-filled'
  | 'thumbs-up-outlined'
  | 'thumbs-up'
  | 'tip'
  | 'warning-2'
  | 'warning'
  | 'zoom'
  // Docons
  | 'more'
  | 'settings'
  | 'people'
  | 'link'
  | 'filter'
  | 'search'
  | 'share'
  | 'lock'
  | 'check-mark'
  | 'delete'
  | 'play'
  | 'calendar'
  | 'enhance-pop'
  | 'flag'
  | 'location-circle'
  | 'home'
  | 'location'
  | 'view'
  | 'download'
  | 'upload'
  | 'dislike'
  | 'like'
  | 'world'
  | 'clock'
  | 'reply'
  | 'clear-night'
  | 'asterisk'
  | 'lightbulb'
  | 'website'
  | 'section'
  | 'developer-tools'
  | 'web-components'
  | 'feedback'
  | 'single-bookmark'
  | 'single-bookmark-solid'
  | 'cloud-import-export'
  | 'text-document'
  | 'arrow-up-right'
  | 'arrow-up8'
  | 'arrow-down8'
  | 'medium-monogram-logo'
  | 'blog'
  | 'deploy'
  | 'more-vertical'
  | 'circle-addition'
  | 'circle-addition-solid'
  | 'file-code'
  | 'asterisk-solid'
  | 'like-solid'
  | 'dislike-solid'
  | 'pod-cast'
  | 'dictionary-download'
  | 'set-history-status'
  | 'reading-settings'
  | 'filter-settings'
  | 'inspect'
  | 'enter-mode'
  | 'wechat'
  | 'weibo'
  | 'brand-linkedin'
  | 'feed'
  | 'check'
  | 'feedback-positive-outline'
  | 'math-multiply'
  | 'octicon-smiley'
  | 'power'
  | 'terminal'
  | 'status-info-outline'
  | 'navigate-refresh'
  | 'sharing'
  | 'exit-mode'
  | 'octicon-issue-closed'
  | 'octicon-issue-opened'
  | 'edit-outline'
  | 'sun'
  | 'locale-globe'
  | 'status-warning-outline'
  | 'status-success-outline'
  | 'brand-facebook'
  | 'brand-github'
  | 'status-error-outline'
  | 'arrow-up-left'
  | 'arrow-right'
  | 'code-lang'
  | 'brand-twitter'
  | 'edit-copy'
  | 'editor-list-bullet'
  | 'octicon-plus-small'
  | 'arrow-down'
  | 'arrow-left'
  | 'status-waiting'
  | 'comment-lines'
  | 'comment-outline'
  | 'mail-message-fill'
  | 'math-minus'
  | 'math-plus'
  | 'math-plus-light'
  | 'user'
  | 'navigate-external'
  | 'play-fill'
  | 'menu'
  | 'navigate-close'
  | 'chevron-up-light'
  | 'chevron-left-light'
  | 'chevron-down-light'
  | 'chevron-right-light'
  | 'status-failure-outline'
  | 'star'
  | 'star-half'
  | 'star-outline'
  | 'topic-architecture'
  | 'topic-deploy'
  | 'topic-download'
  | 'topic-get-started'
  | 'topic-how-to-guide'
  | 'topic-learn'
  | 'topic-overview'
  | 'topic-quickstart'
  | 'topic-tutorial'
  | 'topic-whats-new'
  | 'topic-reference'
  | 'topic-concept'
  | 'topic-video'
  | 'telescope'
  | 'topic-sample'
  | 'question-circle-solid'
  | 'book-solid'
  | 'tag-circle-solid'
  | 'lightbulb-regular'
  | 'brand-dev-to'
  | 'brand-instagram'
  | 'brand-stack-overflow'
  | 'brand-twitch'
  | 'brand-youtube'
  | 'brand-stack-overflow-solid'
  | 'book-open';

export type IconProps = {
  name: iconNames;
  size?: 'default' | 'small' | 'large';
  className?: string;
};

export type iconNames = doconNames;

// const icons = {
//   'arrow-down': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 863 1024">
//       <path d="M805.665 535.767L471.314 869.312V0h-80.566v869.312L57.203 535.767.001 592.164 431.032 1024l431.836-431.836-57.202-56.397z" />
//     </svg>
//   ),
//   'arrow-left': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M832.832 832.832l-256-256c-12.288-12.288-32.768-12.288-44.544 0-12.288 12.288-12.288 32.768 0 44.544l192 192-192 192c-12.288 12.288-12.288 32.768 0 44.544 6.144 6.144 14.336 9.216 22.528 9.216s16.384-3.072 22.528-9.216l256-256c12.288-12.288 12.288-32.768 0-44.544z" />
//     </svg>
//   ),
//   'arrow-right': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M832.832 832.832l-256-256c-12.288-12.288-32.768-12.288-44.544 0-12.288 12.288-12.288 32.768 0 44.544l192 192-192 192c-12.288 12.288-12.288 32.768 0 44.544 6.144 6.144 14.336 9.216 22.528 9.216s16.384-3.072 22.528-9.216l256-256c12.288-12.288 12.288-32.768 0-44.544z" />
//     </svg>
//   ),
//   'arrow-up': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M832.832 832.832l-256-256c-12.288-12.288-32.768-12.288-44.544 0-12.288 12.288-12.288 32.768 0 44.544l192 192-192 192c-12.288 12.288-12.288 32.768 0 44.544 6.144 6.144 14.336 9.216 22.528 9.216s16.384-3.072 22.528-9.216l256-256c12.288-12.288 12.288-32.768 0-44.544z" />
//     </svg>
//   ),
//   bookmark: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path
//         d="M874,874C674.1,1074,349.9,1074,150,874S-50,349.9,150,150S674.1-50,874,150S1074,674.1,874,874z M198.2,198.2
// 	c-173.3,173.3-173.3,454.2,0,627.5s454.2,173.3,627.5,0s173.3-454.2,0-627.5C652.3,25.3,371.7,25.3,198.2,198.2L198.2,198.2
// 	L198.2,198.2z M546.3,220l-68.1,0.5l-0.5,257.3l-257.3,0.5v67.6l257.3,0.5l0.5,257.3l68.1,0.5l0-257.8H804v-68.5H546.3V220
// 	L546.3,220z"
//       />
//     </svg>
//   ),
//   bookmarked: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path
//         d="M874,874C674.1,1074,349.9,1074,150,874S-50,349.9,150,150S674.1-50,874,150S1074,674.1,874,874z M546.3,220l-68.1,0.5
// 	l-0.5,257.3l-257.3,0.5v67.6l257.3,0.5l0.5,257.3l68.1,0.5l0-257.8H804v-68.5H546.3V220L546.3,220z"
//       />
//     </svg>
//   ),
//   checkmark: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M512 1024C229.23 1024 0 794.77 0 512S229.23 0 512 0s512 229.23 512 512-229.23 512-512 512zm0-955.733C266.933 68.267 68.267 266.933 68.267 512S266.933 955.733 512 955.733 955.733 757.067 955.733 512c-.388-244.911-198.822-443.345-443.696-443.733h-.038zm230.741 261.461l-48.469-47.787L512 463.53 329.728 281.941l-47.787 47.787L463.53 512 281.941 694.272l47.787 48.469L512 560.469l182.272 182.272 48.469-48.469L560.469 512l182.272-182.272z" />
//     </svg>
//   ),
//   caution: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M512 1024C229.23 1024 0 794.77 0 512S229.23 0 512 0s512 229.23 512 512-229.23 512-512 512zm0-955.733C266.933 68.267 68.267 266.933 68.267 512S266.933 955.733 512 955.733 955.733 757.067 955.733 512c-.388-244.911-198.822-443.345-443.696-443.733h-.038zm230.741 261.461l-48.469-47.787L512 463.53 329.728 281.941l-47.787 47.787L463.53 512 281.941 694.272l47.787 48.469L512 560.469l182.272 182.272 48.469-48.469L560.469 512l182.272-182.272z" />
//     </svg>
//   ),
//   'chevron-down': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M991.004 308.338l-80.782-80.782-415.289 415.289L80.782 227.556 0 308.338l494.933 494.933 496.071-494.933z" />
//     </svg>
//   ),
//   'chevron-left': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M722.489 991.004l80.782-80.782-415.289-415.289L803.271 80.782 722.489 0 227.556 494.933l494.933 496.071z" />
//     </svg>
//   ),
//   'chevron-right': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M308.338 0l-80.782 80.782 415.289 414.151-415.289 415.289 80.782 80.782 494.933-496.071L308.338 0z" />
//     </svg>
//   ),
//   'chevron-up': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M0 722.489l80.782 80.782 414.151-415.289 415.289 415.289 80.782-80.782-496.071-494.933L0 722.489z" />
//     </svg>
//   ),
//   content: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1018 1024">
//       <path d="M310.457 0h707.435v101.789H310.457V0zM0 0h101.789v101.789H0V0zm310.457 307.404h707.435v101.789H310.457V307.404zM0 307.404h101.789v101.789H0V307.404zm310.457 307.403h707.435v101.789H310.457V614.807zM0 614.807h101.789v101.789H0V614.807zm310.457 307.404h707.435V1024H310.457V922.211zM0 922.211h101.789V1024H0V922.211z" />
//     </svg>
//   ),
//   filter: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M658.286 950.857H365.715V563.931L.001 198.217V73.143h1024v125.074L658.287 563.931zm-219.429-73.143h146.286V533.211l365.714-365.714v-21.211H73.143v21.211l365.714 365.714z" />
//     </svg>
//   ),
//   globe: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M512 0C229.23 0 0 229.23 0 512s229.23 512 512 512 512-229.23 512-512S794.77 0 512 0zm323.129 191.716l-3.413-3.413zM56.889 512v-29.582c3.676.846 7.897 1.33 12.231 1.33s8.555-.485 12.612-1.403l-.381.072c4.663-1.046 10.017-1.645 15.512-1.645 20.652 0 39.327 8.465 52.744 22.115l.01.01c4.55 3.463 7.457 8.882 7.457 14.979 0 .534-.022 1.064-.066 1.587l.005-.068v12.516c15.929 7.396 29.013 21.049 48.356 19.911 8.533 0 14.791 3.413 13.084 14.791s0 11.378 0 17.067c.127.858.2 1.847.2 2.854 0 6.411-2.946 12.134-7.558 15.89l-.037.029c-10.284 11.659-16.562 27.065-16.562 43.936 0 10.282 2.331 20.02 6.495 28.713l-.173-.401c8.592 15.959 16.682 34.772 23.156 54.321l.737 2.568c.708 4.573 2.977 8.519 6.235 11.359l.023.019c10.24 7.964 19.911 16.498 31.289 23.893 4.509 2.292 7.545 6.897 7.545 12.211 0 .71-.054 1.407-.159 2.088l.01-.076c-3.413 36.409-6.827 72.249-9.671 108.089-122.66-82.42-202.456-220.409-203.093-377.076v-.098zM512 967.111c-57.491-.094-112.422-10.941-162.926-30.635l3.068 1.053 69.973-79.076c5.759-5.033 9.377-12.392 9.377-20.596 0-1.364-.1-2.705-.293-4.015l.018.149a15.5 15.5 0 0 1-.253-2.829c0-6.193 3.534-11.561 8.696-14.196l.09-.042c11.378-6.827 22.187-15.929 33.564-22.756 8.224-4.88 13.872-13.356 14.782-23.206l.009-.119c.709-16.853 6.136-32.308 14.983-45.239l-.191.296c11.424-12.093 18.446-28.449 18.446-46.446 0-3.686-.295-7.304-.862-10.83l.051.387a10.192 10.192 0 0 0 2.646-6.87c0-5.655-4.585-10.24-10.24-10.24-.331 0-.658.016-.981.046l.041-.003c-22.756-6.827-44.942-14.791-67.698-21.049-11.613-2.506-20.977-10.37-25.51-20.817l-.09-.232c-3.982-9.671-9.671-17.636-13.653-26.738-2.02-5.379-6.717-9.32-12.425-10.228l-.091-.012c-23.896-3.722-44.079-17.176-56.698-36.105l-.191-.304-9.102-9.671a13.056 13.056 0 0 0-7.902-3.976l-.063-.006c-6.702-1.297-14.41-2.039-22.292-2.039-21.661 0-42.013 5.605-59.685 15.443l.626-.32c-1.877 1.102-4.133 1.753-6.542 1.753s-4.666-.651-6.604-1.786l.062.033c-6.848-2.688-15.218-5.233-23.819-7.167l-1.212-.229c-4.701-.712-8.262-4.724-8.262-9.568 0-.845.108-1.665.312-2.446l-.015.067v-23.893c0-7.964 0-7.964-7.396-8.533l-23.893-3.413c-7.396 0-10.24-5.12-6.827-12.516l6.827-13.084c0-3.413 0-6.258-2.844-6.258s-22.756-7.964-28.444 8.533-38.684-11.378-38.116-21.618 0-26.169 0-39.253a26.128 26.128 0 0 1-.002-.295c0-10.997 8.915-19.911 19.911-19.911 1.207 0 2.389.107 3.536.313l-.121-.018c10.809 0 21.618 3.982 30.151-5.689 1.109-.311 2.383-.489 3.698-.489s2.589.179 3.798.513l-.1-.024c27.876 0 27.876 0 42.098 23.324l3.413 5.689s0 9.102 9.102 6.258c3.452-1.528 5.817-4.923 5.817-8.87 0-1.759-.47-3.409-1.291-4.83l.025.047c0-10.24-3.413-21.049-5.12-31.858a12.287 12.287 0 0 1-.768-4.316c0-3.705 1.61-7.035 4.169-9.326l.012-.01c7.964-8.533 14.791-17.636 22.756-25.6 6.796-5.467 11.109-13.782 11.109-23.105 0-1.482-.109-2.939-.319-4.363l.02.161c0-4.551 0-10.24 3.982-11.378s10.24-10.809 9.102-18.773a18.295 18.295 0 0 1-.461-4.134c0-9.528 7.098-17.398 16.294-18.611l.095-.01h8.533c1.543-1.244 3.528-1.997 5.689-1.997s4.145.753 5.706 2.01l-.018-.014c5.674 7.228 14.412 11.828 24.224 11.828 10.793 0 20.287-5.566 25.766-13.985l.072-.119v-11.378c-6.966-7.376-16.813-11.968-27.733-11.968-.45 0-.899.008-1.345.023l.065-.002h-9.671c-.539-.601-.869-1.4-.869-2.276s.33-1.674.872-2.279l-.003.003h9.671c1.751.4 3.762.629 5.827.629 9.371 0 17.639-4.72 22.557-11.913l.061-.094c4.3-5.639 10.742-9.456 18.091-10.23l.114-.01c5.413-.984 10.186-2.364 14.747-4.165l-.524.182s5.689 0 4.551-3.982-5.689-23.893-16.498-29.013c-17.378-8.355-29.955-24.308-33.507-43.432l-.057-.372v-6.827c17.408-9.664 38.051-19.061 59.455-26.878l3.123-.997a124.234 124.234 0 0 1 17.355 20.605l.281.444c5.552 9.235 15.519 15.319 26.906 15.319 3.605 0 7.068-.61 10.291-1.732l-.22.067c5.689 0 7.964 0 5.689-7.964s0-11.378 3.982-17.067a304.03 304.03 0 0 0 21.61-25.927l.576-.81h35.271c74.72.285 145.159 18.331 207.403 50.132l-2.603-1.208c1.236 6.255 3.005 11.779 5.321 17.006l-.201-.508c5.145 9.548 8.168 20.896 8.168 32.95a70.397 70.397 0 0 1-4.344 24.428l.158-.489c0 5.12 0 7.396 5.12 7.396h35.84c6.258 0 9.102 0 9.671-9.102 1.525-13.577 3.526-25.388 6.116-36.976l-.427 2.274 28.444 23.324c-7.964 7.396-15.929 14.222-22.756 21.618-5.038 6.596-12.907 10.809-21.76 10.809a27.42 27.42 0 0 1-5.726-.601l.179.032c-3.846-.927-8.261-1.459-12.8-1.459s-8.954.532-13.186 1.536l.386-.077 13.084 11.378c7.135 4.359 11.825 12.104 11.825 20.945 0 1.647-.163 3.255-.473 4.811l.026-.156c0 8.533-3.413 11.378-11.378 11.378H709.4c-12.515 0-7.396 0-8.533 5.689-6.258 26.738-4.551 34.133 15.929 51.769a20.959 20.959 0 0 0 14.158 5.473c7.778 0 14.57-4.219 18.214-10.493l.054-.101c5.12-7.396 10.24-15.36 14.791-23.324s8.533-10.809 15.929-9.102 10.24 0 9.671-10.24 0-10.809 5.689-10.809c3.066-.333 6.623-.523 10.223-.523 12.466 0 24.4 2.278 35.408 6.441l-.689-.229c28.982 15.068 53.359 29.981 76.638 46.351l-2.113-1.409c3.982 7.396 7.964 14.791 11.378 22.756-7.396-5.12-10.809 0-12.516 7.396s-3.413 15.36-3.413 19.342-5.689 9.671-13.084 6.827-27.876-10.809-43.804-10.809-22.756-3.413-15.36-26.169c0-6.827 0-9.671-6.258-9.102h-35.271a26.5 26.5 0 0 0-3.788-.264c-7.654 0-14.573 3.149-19.531 8.223l-.005.005c-13.272 13.857-31.716 22.668-52.219 23.321l-.119.003c-13.373.569-23.999 11.549-23.999 25.01 0 .809.038 1.608.113 2.397l-.008-.101c0 5.12 0 10.809-4.551 13.084-18.773 6.827-25.6 24.462-35.84 39.822-3.246 4.909-5.179 10.934-5.179 17.411 0 .679.021 1.354.063 2.023l-.005-.092v56.889a20.992 20.992 0 0 0 6.81 17.052l.016.015c13.393 12.79 24.021 28.351 30.981 45.774l.308.875c3.418 7.832 6.652 14.182 10.197 20.33l-.525-.988c.779 3.483 3.76 6.076 7.377 6.257l.019.001c3.51.581 7.555.913 11.677.913 17.058 0 32.789-5.688 45.397-15.271l-.185.135c16.498-14.222 30.72-10.809 41.529 8.533 3.307 7.13 10.404 11.986 18.636 11.986.449 0 .894-.014 1.336-.043l-.06.003c14.791 0 15.36 0 15.929 15.36s-3.982 21.049 2.844 29.582c6.554 9.148 10.479 20.566 10.479 32.902 0 1.836-.087 3.651-.257 5.443l.018-.229c.46 5.422.722 11.734.722 18.108 0 20.665-2.755 40.687-7.917 59.718l.368-1.594c-.673 1.327-1.067 2.893-1.067 4.551s.394 3.224 1.094 4.61l-.027-.059c6.827 12.516 13.653 25.6 21.049 38.116-84.102 104.751-212.15 171.236-355.726 171.236h-.421.022z" />
//     </svg>
//   ),
//   info: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M512 1024C229.23 1024 0 794.77 0 512S229.23 0 512 0s512 229.23 512 512-229.23 512-512 512zm0-955.733C266.933 68.267 68.267 266.933 68.267 512S266.933 955.733 512 955.733 955.733 757.067 955.733 512c-.388-244.911-198.822-443.345-443.696-443.733h-.038zM477.867 409.6h68.267v409.6h-68.267V409.6zm0-136.533h68.267v68.267h-68.267v-68.267z" />
//     </svg>
//   ),
//   link: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M465.252 178.087H231.958C103.851 178.087 0 281.938 0 410.045s103.851 231.958 231.958 231.958h40.96c-.317-4.991-.497-10.822-.497-16.696s.181-11.705.536-17.489l-.039.793c-.333-4.992-.522-10.822-.522-16.696s.19-11.704.563-17.483l-.041.787h-40.96c-91.224 0-165.176-73.952-165.176-165.176s73.952-165.176 165.176-165.176h233.294c91.224 0 165.176 73.952 165.176 165.176s-73.952 165.176-165.176 165.176h-33.391c-3.393 9.968-5.351 21.451-5.351 33.391s1.958 23.423 5.572 34.145l-.22-.753h33.391c128.107 0 231.958-103.851 231.958-231.958S593.36 178.086 465.253 178.086zm315.214 198.567h-41.405c1.479 9.842 2.442 21.393 2.667 33.124l.004.267a283.973 283.973 0 0 1-2.849 36.679l.178-1.507h41.405c91.224 0 165.176 73.952 165.176 165.176S871.69 775.569 780.466 775.569H547.172c-91.224 0-165.176-73.952-165.176-165.176s73.952-165.176 165.176-165.176h33.837c3.11-9.993 4.901-21.483 4.901-33.391s-1.791-23.398-5.119-34.215l.218.823h-33.837c-128.107 0-231.958 103.851-231.958 231.958S419.065 842.35 547.172 842.35h233.294c128.107 0 231.958-103.851 231.958-231.958S908.573 378.434 780.466 378.434z" />
//     </svg>
//   ),
//   print: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1113 1024">
//       <path d="M1112.837 249.901H886.572V0H250.5v249.901H0v605.967h250.5v168.131h636.072V855.868h226.265zM315.541 65.041h505.991v184.861H315.541zm505.991 893.958H315.541V576.501h505.991v382.498zm226.304-168.131H886.572V511.381H250.5v279.487H65.001V315.062h982.836zM394.915 666.217h336.502v65.001H394.915v-65.001zm0 137.987h336.502v65.001H394.915v-65.001z" />
//     </svg>
//   ),
//   theme: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M511.627 755.863c-134.888 0-244.236-109.348-244.236-244.236s109.348-244.236 244.236-244.236c134.888 0 244.236 109.348 244.236 244.236 0 134.888-109.348 244.236-244.236 244.236zm0-413.036c-93.637.001-169.545 75.909-169.545 169.546s75.908 169.546 169.546 169.546c93.638 0 169.546-75.908 169.546-169.546l-.002-.787v.038c0-93.225-75.574-168.799-168.799-168.799l-.787.002h.04zM473.535 0h74.69v182.244h-74.69V0zM122.684 176.644l52.814-52.814 128.866 128.866-52.814 52.814-128.866-128.866zM0 475.775h182.244v74.69H0v-74.69zm124.161 372.312l128.866-128.866 52.814 52.814-128.866 128.866-52.814-52.814zm351.614-6.331h74.69V1024h-74.69V841.756zm243.771-71.383l52.805-52.823 128.888 128.843-52.805 52.823-128.888-128.843zm122.21-296.838H1024v74.69H841.756v-74.69zM718.075 251.218l128.866-128.866 52.814 52.814-128.866 128.866-52.814-52.814z" />
//     </svg>
//   ),
//   'thumbs-down-filled': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M211.627 68.267H509.27c64.025 6.481 122.77 20.954 177.957 42.53l-4.559-1.57c25.04 10.692 54.717 20.101 85.435 26.71l3.312.597h227.328v436.907H759.127a52.334 52.334 0 0 0-6.003-.335c-14.671 0-27.975 5.858-37.698 15.364L402.775 901.121c-48.469 48.469-85.333 48.469-107.179 38.912-25.364-12.607-42.489-38.34-42.489-68.073 0-1.749.059-3.485.176-5.205l-.013.233v-59.392c4.478-35.008 13.838-66.803 27.461-96.222l-.837 2.014c8.675-21.447 18.002-49.399 25.888-77.948l1.418-6.02H94.891a85.73 85.73 0 0 1-7.456.314c-29.37 0-55.408-14.267-71.561-36.249l-.173-.247C6.059 575.002.398 553.378.398 530.432c0-18.972 3.869-37.04 10.862-53.457l-.338.892 136.533-367.275c10.486-25.052 34.799-42.333 63.149-42.333.359 0 .718.003 1.076.008l-.054-.001z" />
//     </svg>
//   ),
//   'thumbs-down-outlined': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M320.171 944.811c-.738.039-1.601.061-2.47.061a49.637 49.637 0 0 1-21.72-4.97l.297.13c-25.724-12.284-43.179-38.091-43.179-67.974 0-1.784.062-3.554.185-5.307l-.013.236v-59.392c4.478-35.008 13.838-66.803 27.461-96.222l-.837 2.014c8.675-21.447 18.002-49.399 25.888-77.948l1.418-6.02H94.892a85.73 85.73 0 0 1-7.456.314c-29.37 0-55.408-14.267-71.561-36.249l-.173-.247C6.06 575.001.399 553.377.399 530.431c0-18.972 3.869-37.04 10.862-53.457l-.338.892 136.533-367.275c10.486-25.052 34.799-42.333 63.149-42.333.359 0 .718.003 1.076.008l-.054-.001H509.27c64.025 6.481 122.77 20.954 177.957 42.53l-4.559-1.57c25.04 10.692 54.717 20.101 85.435 26.71l3.312.597h227.328v436.907H759.127a52.334 52.334 0 0 0-6.003-.335c-14.671 0-27.975 5.858-37.698 15.364L402.775 901.119c-20.036 24.397-49.167 40.687-82.139 43.657l-.464.034zM211.627 136.533L75.094 503.125c-2.849 7.615-4.498 16.415-4.498 25.6s1.649 17.985 4.667 26.12l-.169-.52c4.096 6.144 16.384 6.827 23.211 6.827h282.624v34.133c-6.857 52.787-20.765 100.698-40.89 145.195l1.295-3.201c-8.538 19.145-16.266 41.91-21.957 65.47l-.571 2.797v59.392c-.441 1.639-.694 3.521-.694 5.461s.253 3.822.728 5.614l-.034-.152c11.562-7.59 21.622-15.915 30.682-25.219l.038-.04 317.44-309.931c21.791-22.038 52.027-35.686 85.451-35.686 2.36 0 4.704.068 7.031.202l-.322-.015h171.349V204.799H771.414c-41.591-5.133-79.407-15.207-114.922-29.746l2.965 1.074c-43.339-17.549-93.936-31.378-146.507-39.148l-3.68-.447z" />
//     </svg>
//   ),
//   'thumbs-down': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M320.171 944.811c-.738.039-1.601.061-2.47.061a49.637 49.637 0 0 1-21.72-4.97l.297.13c-25.724-12.284-43.179-38.091-43.179-67.974 0-1.784.062-3.554.185-5.307l-.013.236v-59.392c4.478-35.008 13.838-66.803 27.461-96.222l-.837 2.014c8.675-21.447 18.002-49.399 25.888-77.948l1.418-6.02H94.892a85.73 85.73 0 0 1-7.456.314c-29.37 0-55.408-14.267-71.561-36.249l-.173-.247C6.06 575.001.399 553.377.399 530.431c0-18.972 3.869-37.04 10.862-53.457l-.338.892 136.533-367.275c10.486-25.052 34.799-42.333 63.149-42.333.359 0 .718.003 1.076.008l-.054-.001H509.27c64.025 6.481 122.77 20.954 177.957 42.53l-4.559-1.57c25.04 10.692 54.717 20.101 85.435 26.71l3.312.597h227.328v436.907H759.127a52.334 52.334 0 0 0-6.003-.335c-14.671 0-27.975 5.858-37.698 15.364L402.775 901.119c-20.036 24.397-49.167 40.687-82.139 43.657l-.464.034zM211.627 136.533L75.094 503.125c-2.849 7.615-4.498 16.415-4.498 25.6s1.649 17.985 4.667 26.12l-.169-.52c4.096 6.144 16.384 6.827 23.211 6.827h282.624v34.133c-6.857 52.787-20.765 100.698-40.89 145.195l1.295-3.201c-8.538 19.145-16.266 41.91-21.957 65.47l-.571 2.797v59.392c-.441 1.639-.694 3.521-.694 5.461s.253 3.822.728 5.614l-.034-.152c11.562-7.59 21.622-15.915 30.682-25.219l.038-.04 317.44-309.931c21.791-22.038 52.027-35.686 85.451-35.686 2.36 0 4.704.068 7.031.202l-.322-.015h171.349V204.799H771.414c-41.591-5.133-79.407-15.207-114.922-29.746l2.965 1.074c-43.339-17.549-93.936-31.378-146.507-39.148l-3.68-.447z" />
//     </svg>
//   ),
//   'thumbs-up-filled': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M787.115 944.811H489.472c-63.32-6.592-121.348-21.054-175.85-42.522l4.5 1.562c-25.572-9.798-56.254-18.534-87.864-24.674l-3.613-.585H0V440.32h239.616a50.29 50.29 0 0 0 6.153.366c14.755 0 28.072-6.16 37.519-16.048l.019-.02 312.661-312.661c48.469-48.469 86.699-47.787 106.496-38.912 25.751 12.471 43.195 38.405 43.195 68.414 0 1.87-.068 3.724-.201 5.56l.014-.246V204.8c-4.478 35.008-13.838 66.803-27.461 96.222l.837-2.014c-9.557 27.307-21.163 58.027-27.989 83.968h212.309a85.146 85.146 0 0 1 7.965-.361c29.581 0 55.756 14.585 71.725 36.957l.182.268c9.447 18.081 14.99 39.492 14.99 62.197 0 18.684-3.753 36.49-10.546 52.708l.335-.9-136.533 366.592c-9.967 26.141-34.829 44.374-63.949 44.374h-.234.012z" />
//     </svg>
//   ),
//   'thumbs-up-outlined': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M787.115 944.811H489.472c-63.32-6.592-121.348-21.054-175.85-42.522l4.5 1.562c-25.572-9.798-56.254-18.534-87.864-24.674l-3.613-.585H0V440.32h239.616a50.29 50.29 0 0 0 6.153.366c14.755 0 28.072-6.16 37.519-16.048l.019-.02 312.661-312.661c48.469-48.469 86.699-47.787 106.496-38.912 25.751 12.471 43.195 38.405 43.195 68.414 0 1.87-.068 3.724-.201 5.56l.014-.246V204.8c-4.478 35.008-13.838 66.803-27.461 96.222l.837-2.014c-9.557 27.307-21.163 58.027-27.989 83.968h212.309a85.146 85.146 0 0 1 7.965-.361c29.581 0 55.756 14.585 71.725 36.957l.182.268c9.447 18.081 14.99 39.492 14.99 62.197 0 18.684-3.753 36.49-10.546 52.708l.335-.9-136.533 366.592c-9.967 26.141-34.829 44.374-63.949 44.374h-.234.012zM68.267 810.325h158.379c42.509 4.901 81.289 14.996 117.685 29.746l-2.997-1.074c43.586 17.373 94.313 30.553 147.07 37.225l3.117.322h297.643l136.533-366.592c4.322-8.707 6.852-18.962 6.852-29.808a68.19 68.19 0 0 0-3.579-21.873l.141.481c-4.096-6.144-16.384-6.827-23.893-6.827H614.402v-34.133c6.101-52.369 19.332-100.133 38.807-144.535l-1.261 3.223c8.538-19.145 16.266-41.91 21.957-65.47l.571-2.797v-61.44c.311-1.642.489-3.531.489-5.461s-.178-3.819-.519-5.651l.029.19c-11.885 7.272-22.178 15.394-31.409 24.582l.006-.006-311.296 312.661c-22.301 22.017-52.959 35.615-86.793 35.615-1.888 0-3.766-.042-5.633-.126l.265.009H68.266z" />
//     </svg>
//   ),
//   'thumbs-up': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M787.115 944.811H489.472c-63.32-6.592-121.348-21.054-175.85-42.522l4.5 1.562c-25.572-9.798-56.254-18.534-87.864-24.674l-3.613-.585H0V440.32h239.616a50.29 50.29 0 0 0 6.153.366c14.755 0 28.072-6.16 37.519-16.048l.019-.02 312.661-312.661c48.469-48.469 86.699-47.787 106.496-38.912 25.751 12.471 43.195 38.405 43.195 68.414 0 1.87-.068 3.724-.201 5.56l.014-.246V204.8c-4.478 35.008-13.838 66.803-27.461 96.222l.837-2.014c-9.557 27.307-21.163 58.027-27.989 83.968h212.309a85.146 85.146 0 0 1 7.965-.361c29.581 0 55.756 14.585 71.725 36.957l.182.268c9.447 18.081 14.99 39.492 14.99 62.197 0 18.684-3.753 36.49-10.546 52.708l.335-.9-136.533 366.592c-9.967 26.141-34.829 44.374-63.949 44.374h-.234.012zM68.267 810.325h158.379c42.509 4.901 81.289 14.996 117.685 29.746l-2.997-1.074c43.586 17.373 94.313 30.553 147.07 37.225l3.117.322h297.643l136.533-366.592c4.322-8.707 6.852-18.962 6.852-29.808a68.19 68.19 0 0 0-3.579-21.873l.141.481c-4.096-6.144-16.384-6.827-23.893-6.827H614.402v-34.133c6.101-52.369 19.332-100.133 38.807-144.535l-1.261 3.223c8.538-19.145 16.266-41.91 21.957-65.47l.571-2.797v-61.44c.311-1.642.489-3.531.489-5.461s-.178-3.819-.519-5.651l.029.19c-11.885 7.272-22.178 15.394-31.409 24.582l.006-.006-311.296 312.661c-22.301 22.017-52.959 35.615-86.793 35.615-1.888 0-3.766-.042-5.633-.126l.265.009H68.266z" />
//     </svg>
//   ),
//   tip: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 699 1024">
//       <path d="M349.41 0C91.816 0 0 191.283 0 349.41c0 75.875 52.922 151.751 103.93 224.438a416.844 416.844 0 0 1 95.869 196.964l.41 2.608v249.943h299.039V774.058c14.145-77.546 47.96-145.518 96.067-200.708l-.426.499c51.009-72.687 106.481-148.563 106.481-224.438 0-158.127-93.729-349.41-351.96-349.41zm-85.44 960.239V828.892h171.517v131.347zm278.635-422.097c-53.172 62.238-90.823 139.275-106.05 224.094l-.431 2.895H263.332c-15.915-87.753-53.768-164.77-107.658-227.634l.54.645c-45.349-51.616-77.895-115.56-92.023-186.156l-.43-2.576c-.543-6.365-.853-13.775-.853-21.257 0-146.491 118.754-265.245 265.245-265.245 7.482 0 14.891.31 22.216.917l-.96-.064c7.14-.683 15.437-1.072 23.825-1.072 146.491 0 265.245 118.754 265.245 265.245 0 7.559-.316 15.044-.936 22.443l.065-.968c-15.038 73.442-48.482 137.431-95.302 189.066l.298-.334z" />
//     </svg>
//   ),
//   'warning-2': (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M512 1024C229.23 1024 0 794.77 0 512S229.23 0 512 0s512 229.23 512 512-229.23 512-512 512zm0-955.733C266.933 68.267 68.267 266.933 68.267 512S266.933 955.733 512 955.733 955.733 757.067 955.733 512c-.388-244.911-198.822-443.345-443.696-443.733h-.038zm-34.133 204.8h68.267v409.6h-68.267v-409.6zm0 477.866h68.267V819.2h-68.267v-68.267z" />
//     </svg>
//   ),
//   warning: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1016 1024">
//       <path d="M473.42 429.609h65.39v341.987h-65.39V429.609zm0 407.377h65.39v65.39h-65.39v-65.39zM1016.153 1024H0L508.077 0zm-910.876-65.39h805.599L508.077 147.126z" />
//     </svg>
//   ),
//   zoom: (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
//       <path d="M654.325 0C450.159 0 284.65 165.509 284.65 369.675c.741 88.879 32.734 170.146 85.508 233.491l-.482-.596L.001 972.245 52.495 1024 422.17 654.325c62.35 52.557 143.47 84.629 232.071 85.025h.085c204.166 0 369.675-165.509 369.675-369.675S858.492 0 654.326 0zm0 665.415c-163.333 0-295.74-132.407-295.74-295.74s132.407-295.74 295.74-295.74 295.74 132.407 295.74 295.74-132.407 295.74-295.74 295.74z" />
//     </svg>
//   ),
// };

export const Icon: React.FC<IconProps> = ({ name, size = 'default', className = '' }) => {
  if (icomoonClasses.includes(name)) {
    return <span className={`icon ${className} icomoon size-${size} icon-${name}`} aria-hidden="true"></span>;
  }
  return <span className={`icon ${className} docon size-${size} docon-${name}`} aria-hidden="true"></span>;
};

export const StyledIcon = styled.div`
  /* width: 16px;
  height: 16px; */
  /* display: inline-flex;
  justify-content: center;
  align-items: center; */
  /* 
  svg {
    width: 100%;
    height: 100%;
  }

  &.size-small {
    width: 14px;
    height: 14px;
  }
  &.size-large {
    width: 24px;
    height: 24px;
  } */
`;

export default Icon;
